import { Link } from '@/components/Link'
import { Typography } from '@/components/Typography'
import { ArchiveItem } from '@/types/cms'
import { getLinkPathname } from '@/utils/urls'
import styles from './SimpleTeaser.module.scss'

const SimpleTeaser = ({ teaser }: { teaser: ArchiveItem }) => {
  const dateObject = new Date(teaser.date)
  return (
    <article title={teaser.data.title}>
      <Link href={getLinkPathname(teaser.data.url)} className={styles.link}>
        <div className={styles.wrapper}>
          <h2>
            <Typography as="div" variant="s" weight="bold" color="blue">
              {teaser.data.title}
            </Typography>
          </h2>
          <Typography as="span" variant="xxxl" weight="bold" className={styles.message}>
            {teaser.data.message}
          </Typography>

          <Typography as="span" variant="xs" color="darkgrey">
            <span>
              {dateObject.toLocaleDateString('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
              })}
              &nbsp;|&nbsp;
              {dateObject.toLocaleTimeString('de-DE', {
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
          </Typography>
        </div>
      </Link>
    </article>
  )
}

export default SimpleTeaser
